<template>
    <div v-if="selectedAdvisor && selectedAdvisor.banner" v-html="selectedAdvisor.banner"></div>
    <div class="advisor-details">
        <div class="advisor-details-outer">
            <div class="row advisor-details-inner">
                <div class="col-lg-6 advisor-search-container single">
                    <div class="advisor-search-container__results--list-item">
                        <div class="row back-cta-block" v-if="!isSpecificAdvisor">
                            <div class="col-12">
                                <button v-on:click.stop="unSelectAdvisorClick">{{ text("backToResults") }}</button>
                            </div>
                        </div>
                        <div class="row advisor-search-container__heading d-sm-flex d-md-none">
                            <div class="advisor-search-container__image col" v-if="selectedAdvisor.image">
                                <img :src="selectedAdvisor.image" :alt="('Headshot of ' + selectedAdvisor.firstName + ' ' + selectedAdvisor.lastName)" tabindex="-1" ref="mobileImageRef" />
                            </div>
                            <div class="col mobile-custom-adjustment">
                                <strong v-if="selectedAdvisor.isInvestmentServices">{{ text("investmentServicesHeading") }}</strong>
                                <h1 class="h3 advisor-search-container__name">{{ selectedAdvisor.firstName }} {{ selectedAdvisor.lastName }}</h1>
                                <div class="advisor-search-container__jobtitle" v-if="selectedAdvisor.advisorTitle">{{ selectedAdvisor.advisorTitle }}</div>
                                <div class="cta_btns" v-if="selectedAdvisor.applyNowCta || selectedAdvisor.clientLoginCta" v-html="ctaHtml"></div>
                            </div>
                        </div>
                        <div class="row advisor-search-container__npn d-sm-block d-md-none" v-if="selectedAdvisor.nmlsNumber || selectedAdvisor.ailNumber || selectedAdvisor.npmNumber">
                            <div v-if="selectedAdvisor.nmlsNumber" class="col">{{ text("nmls") }} #{{ selectedAdvisor.nmlsNumber }}</div>
                            <div v-if="selectedAdvisor.ailNumber" class="col">{{ text("ail") }} #{{ selectedAdvisor.ailNumber }}</div>
                            <div v-if="selectedAdvisor.npmNumber" class="col">{{ text("npn") }} #{{ selectedAdvisor.npmNumber }}</div>
                        </div>
                        <div class="row advisor-search-container__detail">
                            <div class="col-4 d-none d-md-flex">
                                <div class="advisor-search-container__image">
                                    <img :src="selectedAdvisor.image" :alt="('Headshot of ' + selectedAdvisor.firstName + ' ' + selectedAdvisor.lastName)" tabindex="-1" ref="desktopImageRef" />
                                    <div class="advisor-search-container__npn" v-if="selectedAdvisor.nmlsNumber">{{ text("nmls") }} #{{ selectedAdvisor.nmlsNumber }}</div>
                                    <div class="advisor-search-container__npn" v-if="selectedAdvisor.ailNumber">{{ text("ail") }} #{{ selectedAdvisor.ailNumber }}</div>
                                    <div class="advisor-search-container__npn" v-if="selectedAdvisor.npmNumber">{{ text("npn") }} #{{ selectedAdvisor.npmNumber }}</div>
                                </div>
                                <div class="col d-none d-sm-block d-md-none">
                                    <h2 class="h3 advisor-search-container__name">{{ selectedAdvisor.firstName }} {{ selectedAdvisor.lastName }}</h2>
                                    <div class="advisor-search-container__jobtitle" v-if="selectedAdvisor.advisorTitle">{{ selectedAdvisor.advisorTitle }}</div>
                                    <div class="cta_btns" v-if="selectedAdvisor.applyNowCta || selectedAdvisor.clientLoginCta" v-html="ctaHtml"></div>
                                </div>
                            </div>
                            <div class="col details">
                                <div class="section d-none d-md-block">
                                    <h2 class="h3 advisor-search-container__name">{{ selectedAdvisor.firstName }} {{ selectedAdvisor.lastName }}</h2>
                                    <div class="advisor-search-container__jobtitle" v-if="selectedAdvisor.advisorTitle">{{ selectedAdvisor.advisorTitle }}</div>
                                    <div class="cta_btns" v-if="selectedAdvisor.applyNowCta || selectedAdvisor.clientLoginCta" v-html="ctaHtml"></div>
                                </div>
                                <div class="section" v-if="selectedAdvisor.finraBrokerCheck">
                                    {{ text("finraDescriptor") }}<br />
                                    <a class="link" :href="'https://brokercheck.finra.org/individual/summary/' + selectedAdvisor.finraBrokerCheck" target="_blank">{{ selectedAdvisor.finraBrokerCheck }}</a>
                                </div>
                                <div class="section" v-if="hasPhone">
                                    <h3>{{ text("callHeadline") }}</h3>
                                    <span v-if="selectedAdvisor.officePhoneNumber">P: <a v-if="selectedAdvisor.officePhoneNumber" v-bind:href="this.telephoneHref(selectedAdvisor.officePhoneNumber)" class="tel link">{{ formatTelephone(selectedAdvisor.officePhoneNumber) }}</a></span>
                                    <br v-if="selectedAdvisor.officePhoneNumber" />
                                    <span v-if="selectedAdvisor.cellPhoneNumber">C: <a v-if="selectedAdvisor.cellPhoneNumber" v-bind:href="this.telephoneHref(selectedAdvisor.cellPhoneNumber)" class="tel link">{{ formatTelephone(selectedAdvisor.cellPhoneNumber) }}</a></span>
                                    <br v-if="selectedAdvisor.cellPhoneNumber" />
                                    <span v-if="selectedAdvisor.faxPhoneNumber">F: <span class="tel link">{{ formatTelephone(selectedAdvisor.faxPhoneNumber) }}</span></span>
                                </div>
                                <div class="section advisor-search-container__languages" v-if="false">
                                    <h3>{{ text("languagesHeading") }}</h3>
                                    {{ selectedAdvisor.languages }}
                                </div>
                                <div class="section" v-if="selectedAdvisor.emailAddress || selectedAdvisor.linkedInConnection">
                                    <h3>{{ text("emailHeading") }}</h3>
                                    <a v-if="selectedAdvisor.emailAddress" v-bind:href="emailHref" class="email link">{{ selectedAdvisor.emailAddress }}</a><br />
                                    <a v-if="selectedAdvisor.linkedInConnection" v-bind:href="selectedAdvisor.linkedInConnection" target="_blank" class="link">{{ text("connectCta") }}</a><br />
                                </div>
                                <div class="section" v-if="selectedAdvisor.address && !isDirectConsumer">
                                    <h3>{{ text("visitHeading") }}</h3>
                                    <span v-html="address"></span>
                                </div>
                                <div class="section" v-if="selectedAdvisor.address && !isDirectConsumer">
                                    <img src="/assets/images/directions_icon.svg" alt="" /> <a v-bind:href="directions" target="_blank" class="link">{{ text("directions") }}</a><br />
                                    <img class="icon" src="/assets/images/information_icon.svg" alt="" /> <a :href="selectedAdvisor.locationDetailPageUrl" target="_blank" class="link">{{ text("branchInfo") }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6"></div>
            </div>
            <div v-if="!isDirectConsumer" class="map-container advisor-details-map" role="region" aria-label="map">
                <GoogleMap
                    ref="map"
                    :api-key="effectiveGoogleApi.geoKey"
                    mapId="78754c129d1b9610e39d8bea"
                    :zoom="17"
                    :center="center"
                    class="map"
                    @click="expandMap"
                    :zoomControl="true"
                    :mapTypeControl="false"
                    :scaleControl="false"
                    :streetViewControl="false"
                    :rotateControl="false"
                    :fullscreenControl="true"
                    :disableDefaultUI="false"
                    :libraries="['places', 'marker']"
                >
                    <AdvancedMarker
                        v-for="m in marker"
                        :key="m.id"
                        :options="{
                            position: m.position,
                            title: m.title
                        }"
                    >
                        <template #content>
                            <img 
                                :src="m.icon.url" 
                                :style="{
                                    width: m.icon.scaledSize?.width + 'px' || '30px',
                                    height: m.icon.scaledSize?.height + 'px' || '30px'
                                }"
                                :alt="m.title"
                            />
                        </template>
                    </AdvancedMarker>
                </GoogleMap>
            </div>
        </div>
        <div v-if="selectedAdvisor.disclaimers && fromListPage" class="container full-width-container bleed-bgs disclaimer-container">
            <div class="row">
                <div class="col-md-12">
                    <div class="disclaimer disclaimer-ul" v-html="selectedAdvisor.disclaimers"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { inject } from "vue";
import { locText } from "../../../utils/useText";
import { formatAddress, formatDirectionsLink, formatEmailLink, formatPhoneNumber, formatTelephoneHref } from "../../../utils/functions";
import { googleApi, defaultOpt } from "../../../config/map";

const MARKER_ICON = "/assets/images/branch.svg";

export default {
    setup() {
        const injectedApiKey = inject('googleMapsApiKey', null);
        const injectedConfig = inject('googleMapsConfig', null);
        
        return {
            injectedApiKey,
            injectedConfig
        };
    },
    data() {
        return {
            center: defaultOpt.pos,
            marker: [],
            googleApi: googleApi
        }
    },
    mounted() {
        if(!this.isDirectConsumer) {
            this.center = {
                lat: this.selectedAdvisor.geocode.latitude,
                lng: this.selectedAdvisor.geocode.longitude
            };
            
            this.$nextTick(() => {
                this.marker.push({
                    id: this.selectedAdvisor.id,
                    title: this.selectedAdvisor.fullName || 
                           `${this.selectedAdvisor.firstName} ${this.selectedAdvisor.lastName}` || 
                           'Advisor Location',
                    position:  {
                        lat:  this.selectedAdvisor.geocode.latitude,
                        lng:  this.selectedAdvisor.geocode.longitude
                    },
                    icon: {
                        url: MARKER_ICON,
                        scaledSize: { width: 30, height: 30 }
                    }
                });
                setTimeout(() => {
                    this.boundMarkers();
                }, 100);
            });
        }

        if (!this.userSearchLocation || !this.userSearchLocation.lat || !this.userSearchLocation.lng) {
            this.geolocateUser();
        }

        if (typeof HERO_speedbump != "undefined") {
            setTimeout(function(){
                HERO_speedbump.init();
            }, 1000);
        }

        if (this.isMobile)
        {
            this.$refs.mobileImageRef.focus();
        }
        else {
            this.$refs.desktopImageRef.focus();
        }
    },
    computed: {
        effectiveGoogleApi() {
            return {
                mapKey: this.injectedApiKey || googleApi.mapKey,
                geoKey: this.injectedApiKey || googleApi.geoKey
            };
        },
        isMobile() {
            return this.$mq === 'mobile';
        },
        address() {
            return formatAddress(this.selectedAdvisor);
        },
        ctaHtml() {
            let html = "";
            if (this.selectedAdvisor.applyNowCta) {
                html = this.selectedAdvisor.applyNowCta;
                if (this.selectedAdvisor.clientLoginCta) {
                    html = html.concat(this.selectedAdvisor.clientLoginCta);
                }
            }
            else if (this.selectedAdvisor.clientLoginCta) {
                html = this.selectedAdvisor.clientLoginCta;
            }
            return html;
        },
        directions() {
            return formatDirectionsLink(this.selectedAdvisor, this.userSearchLocation);
        },
        distance() {
            return parseFloat(this.selectedAdvisor.distance).toFixed(1) + " " + this.text("distance");
        },
        emailHref() {
            return formatEmailLink(this.selectedAdvisor);
        },
        formattedPhoneNumber() {
            return formatPhoneNumber(this.phone);
        },
        hasPhone() {
            return this.selectedAdvisor.officePhoneNumber || this.selectedAdvisor.cellPhoneNumber || this.selectedAdvisor.faxPhoneNumber;
        },
        isSpecificAdvisor() {
            return this.$store.getters.isSpecificAdvisor;
        },
        selectedAdvisor() {
            return this.$store.getters.selectedAdvisor;
        },
        userSearchLocation() {
            return this.$store.getters.userSearchLocation;
        },
        isDirectConsumer: {
            get() {
                return this.$store.getters.isDirectConsumer;
            }
        }
    },
    methods: {
        ...mapActions(["geolocateUser"]),
        boundMarkers() {
            if (this.$refs.map && this.$refs.map.map && typeof google !== 'undefined' && google.maps) {
                // For single marker, just center and zoom to it
                if (this.marker.length === 1) {
                    const markerPosition = {
                        lat: this.marker[0].position.lat,
                        lng: this.marker[0].position.lng
                    };
                    
                    this.$refs.map.map.setZoom(17);
                    this.$refs.map.map.setCenter(markerPosition);
                } else {
                    // Multiple markers - use bounds
                    const bounds = new window.google.maps.LatLngBounds();
                    for (var m in this.marker) {
                        if (this.marker.hasOwnProperty(m)) {
                            let lat = parseFloat(this.marker[m].position.lat);
                            let lng = parseFloat(this.marker[m].position.lng);
                            let myLatlng = new window.google.maps.LatLng(lat, lng);
                            bounds.extend(myLatlng);
                        }
                    }

                    // Don't zoom in too far on only one marker
                    if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
                        var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.001, bounds.getNorthEast().lng() + 0.001);
                        var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.001, bounds.getNorthEast().lng() - 0.001);
                        bounds.extend(extendPoint1);
                        bounds.extend(extendPoint2);
                    }

                    this.$refs.map.map.fitBounds(bounds);
                }
            } else {
                // Retry if map isn't ready yet
                setTimeout(() => {
                    this.boundMarkers();
                }, 100);
            }
        },
        contractMap(){
            if(this.$mq !== 'desktop') {
                EventBus.expandMap(false);
                setTimeout(()=> {
                    EventBus.scrollToTopMobile();
                },600);
            }
        },
        expandMap(){
            EventBus.expandMap(true);
            EventBus.scrollToTopMobile(0);
        },
        telephoneHref(phoneNumber) {
            return formatTelephoneHref(phoneNumber);
        },
        formatTelephone(phoneNumber) {
            return formatPhoneNumber(phoneNumber);
        }
    },
    mixins: [locText],
    props: {
        fromListPage: Boolean,
        unSelectAdvisorClick: Function
    }
}
</script>
